import { useMediaQuery, useTheme } from '@material-ui/core'
import React, { FC, useMemo } from 'react'

import { components } from '@plandi/common/src/generated'
import { useAdvertisingRowStyles } from './advertising-row.styles'
import { getUniqueRandomIdxs, useTranslation } from '@plandi/common'
import Image from 'next/image'

type AdvertisingRowProps = {
  data?: components['schemas']['AdvertisingItemResource'][]
}

export const AdvertisingRow: FC<AdvertisingRowProps> = ({ data }) => {
  const { data: translate } = useTranslation()
  const classes = useAdvertisingRowStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const BANNERS_MAX_COUNT = 3

  const [firstIdx, secondIdx, thirdIdx] = useMemo(
    () => getUniqueRandomIdxs(data?.length, BANNERS_MAX_COUNT),
    [data?.length]
  )

  if (!data?.length) {
    return <></>
  }

  const randomBanners = [data[firstIdx], data[secondIdx], data[thirdIdx]]
  const normalizedData =
    data?.length <= BANNERS_MAX_COUNT ? data : randomBanners
  const randomIdx = Math.floor(Math.random() * normalizedData.length)

  return (
    <div className={classes.root}>
      {(isMobile ? [normalizedData[randomIdx]] : normalizedData).map(
        (adData, idx) => (
          <div key={(adData.action || '') + idx} className={classes.adItem}>
            <a href={adData.action}>
              <Image
                width={300}
                height={150}
                className={classes.adImage}
                src={adData.image as NonNullable<typeof adData.image>}
                alt={translate?.['photo-adverting'] ?? ''}
              />
            </a>
          </div>
        )
      )}
    </div>
  )
}
